import React from "react";
import policeman from "../../assets/icons/policeman.svg";
// import wait from "../../assets/icons/oval.svg";
// import conv from "../../assets/icons/conversation.svg";
// import speech from "../../assets/icons/speech-bubble.svg";
import {DialogTextList} from './dialog-text-list/dialog-text-list';

import "./dialog.css";

export class Dialog extends React.Component {
  render() {
    return (
      <div className="dialog">
        <img
          alt="policeman"
          className={
            this.props.jump
              ? "dialog__policeman dialog__policeman_jumping"
              : "dialog__policeman"
          }
          src={policeman}
        />
        <div className="dialog__text">
          <DialogTextList  dialogData={this.props.dialogData}/>
        </div>
      </div>
    );
  }
}
